export default __webpack_public_path__ + "static/6ff30ee84198addd635260b79aac9d76.jpg";